type SearchableMember = { name: string; memberCode: string; isTeacher: boolean };

export function matchesDevPreviewMember(member: SearchableMember, query: string) {
  const terms = query.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
  const text = `${member.name} ${member.memberCode} ${member.isTeacher ? '老師' : '學員'}`.toLocaleLowerCase();
  const digits = member.memberCode.replace(/-/g, '');
  return terms.every(term => text.includes(term)
    || (/^[\d-]+$/.test(term) && /\d/.test(term) && digits.includes(term.replace(/-/g, ''))));
}
